import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { useUnsafeTranslation } from '../../../../i18next';

const Container = styled('div')((p) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  minHeight: 400,

  '&&': {
    '> *': {
      marginBottom: p.theme.spacing(2),
      textAlign: 'center'
    }
  }
}));

const EmptyState = ({
  title,
  body
}: {
  title?: React.ReactElement;
  body?: React.ReactElement;
}) => {
  return (
    <Container>
      {title && (
        <Typography variant="h2" color="primary" gutterBottom={true}>
          {title}
        </Typography>
      )}

      {body && <Typography variant="body1">{body}</Typography>}
    </Container>
  );
};
export const EmptyStateNoReportableTemplates = () => {
  const { t } = useUnsafeTranslation();
  return (
    <EmptyState
      title={t('No experience templates found')}
      body={t(
        `You currently don't have any active experience templates to report on.`
      )}
    />
  );
};

export const EmptyStateNoInstances = () => {
  const { t } = useUnsafeTranslation();
  return (
    <EmptyState
      title={t('Nothing to display')}
      body={t('No data to display based on your current filters')}
    />
  );
};
